import { render, staticRenderFns } from "./qcvendorslist.vue?vue&type=template&id=8972e7f2"
import script from "./qcvendorslist.vue?vue&type=script&lang=js"
export * from "./qcvendorslist.vue?vue&type=script&lang=js"
import style0 from "./qcvendorslist.vue?vue&type=style&index=0&id=8972e7f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports